<template>
  <div>
    <div v-if="!openScan">
      <div class="bg-white padding">
        <div class="input-item flex" style="justify-content: space-between">
          <div style="display: flex; align-items: center">
            <div class="line"></div>
            <span class="text-nowrap">請輸入條碼</span>
          </div>
          <div class="icon-scan" @click="openScanner">掃描</div>
        </div>
        <div class="form">
          <div>
            <div class="field">
              <span class="required">*</span>
              第一段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode1.placeholder}`"
              class="input vinput"
              maxlength="9"
              v-model.trim="form.barcode1"
              @blur="verifyForm('barcode1')"
              @input="verifyInput('barcode1')"
              :class="verify.barcode1.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode1.text }}</div>
          </div>
          <div>
            <div class="field">
              <span class="required">*</span>
              第二段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode2.placeholder}`"
              class="input vinput"
              maxlength="20"
              v-model.trim="form.barcode2"
              @blur="verifyForm('barcode2')"
              @input="verifyInput('barcode2')"
              :class="verify.barcode2.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode2.text }}</div>
          </div>
          <div>
            <div class="field">
              <span class="required">*</span>
              第三段條碼
            </div>
            <input
              type="text"
              name="id_card_number"
              :placeholder="`${verify.barcode3.placeholder}`"
              class="input vinput"
              maxlength="15"
              v-model.trim="form.barcode3"
              @blur="verifyForm('barcode3')"
              @input="verifyInput('barcode3')"
              :class="verify.barcode3.status ? '' : 'error'"
            />
            <div class="required">{{ verify.barcode3.text }}</div>
          </div>
        </div>
        <button class="btn btn-primary" :disabled="isSearchButtonDisable" ref="search_btn" @click="getPaymentInformation(false)">查詢帳單</button>
      </div>
      <div class="padding description">
        <ul class="text-gray2">
         <li>台固媒體股份有限公司，僅提供網路費用繳費服務。</li>
         <li>可使用悠遊付錢包、銀行帳戶連結進行繳費扣款。</li>
         <li>繳費後無法取消，若需退費請洽<a @click="openCableFeeVendorServiceUrl()">各業者客服中心。</a></li>
         <li>綁定後，下期帳單將透過APP通知繳費(請留意推播或首頁左上角小鈴鐺)，不再寄送紙本或簡訊帳單。</li>
        </ul>
      </div>
    </div>
    <div v-else>
      <triple-bar-code @clickOpen="openScanner">
        <li slot="information">繳費規範限制請參閱紙本繳費單注意事項。</li>
      </triple-bar-code>
    </div>
  </div>
</template>
<script>
import { queryBillList } from '../../api/api';
import TripleBarCode from '../../components/TripleBarCode';
import { mapActions } from 'vuex';

export default {
  name: 'tv-fee',
  components: {
    TripleBarCode,
  },
  data() {
    return {
      openScan: false,
      form: {
        barcode1: '',
        barcode2: '',
        barcode3: '',
      },
      verify: {
        barcode1: {
          status: true,
          text: '',
          placeholder: '共 9 碼',
          verifyRegex: '^[0-9]{6}[0-9a-zA-Z]{3}$',
          verifyErrorText: '前6碼需為數字，後3碼限數字及英文'
        },
        barcode2: {
          status: true,
          text: '',
          placeholder: '共 14 ~ 20 碼',
          verifyRegex: '^([0-9a-zA-Z]{16,20}|[0-9a-zA-Z]{14})$',
          verifyErrorText: '需為 14 ~ 20 碼'
        },
        barcode3: {
          status: true,
          text: '',
          placeholder: '共 10 或 15 碼',
          verifyRegex: '^([a-zA-Z0-9]{10}|[0-9a-zA-Z]{15})$',
          verifyErrorText: '需為 10 ~ 15 碼'
        },
      },
      verifyInputRule: {
        barcode1: false,
        barcode2: false,
        barcode3: false,
      },
    };
  },
  created() {
  },
  computed: {
    isSearchButtonDisable() {
      return !Object.values(this.verifyInputRule).every((i) => i === true);
    },
  },
  methods: {
    ...mapActions(['setReadyToPayBill', 'sentApp']),
    openCableFeeVendorServiceUrl() {
      this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: 'https://ephttp.easycard.com.tw/app_html/cableOperator_20220803.pdf' },
      });
    },
    verifyForm(fieldName) {
      if (!this.verifyInput(fieldName)) {
        this.verify[fieldName].status = false;
        this.verify[fieldName].text = this.verify[fieldName].verifyErrorText;
        return false;
      } else {
        this.verify[fieldName].status = true;
        this.verify[fieldName].text = '';
        return true;
      }
    },
    verifyInput(fieldName) {
      const regexp = RegExp(/[\d|a-zA-Z|\\+|\\=|\\.|\-|\\$|\\|\s]+$/);
      let result = regexp.test(this.form[fieldName]);
      this.form[fieldName] = this.form[fieldName].toUpperCase();

      if (result) {
        if (new RegExp(this.verify[fieldName].verifyRegex).test(this.form[fieldName])) {
          this.verifyInputRule[fieldName] = true;
        } else {
          this.verifyInputRule[fieldName] = false;
        }
      } else {
        this.verifyInputRule[fieldName] = false;
      }
      return this.verifyInputRule[fieldName];
    },
    getScannerBarcodeRegex() {
      let regexList = []
      for (let k in this.verify) {
        regexList.push(this.verify[k].verifyRegex);
      }
      return regexList;
    },
    openScanner() {
      window.getScanningResult = this.getScanningResult;

      let form = Object.assign({}, this.form);
      for (let k in this.verify) {
        if (this.verify[k].status === false) {
          form[k] = '';
        }
      }
      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: 3, content: form, isAllowInput: true, barcodeRegex: this.getScannerBarcodeRegex() },
      });
    },
    getScanningResult(taxBarcode) {
      this.getFormData(taxBarcode);
    },
    getFormData(taxData) {  
      let d = JSON.parse(taxData);
      for (let i = 0; i <= 2; i++) {
        this.form['barcode' + (i + 1)] = d[i];
        if (d[i]) {
          this.verifyForm(`barcode${i + 1}`);
        }
      }
    },
    validateForm() {
      var allSuccess = true;
      for (let i = 0; i <= 2; i++) {
        allSuccess = allSuccess && this.verifyForm(`barcode${i + 1}`);
      }
      return allSuccess;
    },
    getPaymentInformation(isScanning) {
      if (!this.validateForm()) {
        return;
      }
      var form = {
        payment_item_id: 'KBRO',
        payment_query_type: 3,
        parameter1: this.form.barcode1,
        parameter2: this.form.barcode2,
        parameter3: this.form.barcode3,
        payment_custom_id: isScanning ? '' : '',
      };
      queryBillList(form).then((res) => {
        if (res.error == null) {
          this.setReadyToPayBill(res);
          this.$router.push({
            path: '/goPay',
            query: form,
          });
        } else {
          alert(res.error.message);
        }
      });
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
.required {
  margin-top: 2pt;
  margin-bottom: 26pt;
  font-size: 12pt;
}
</style>
